import { render, staticRenderFns } from "./ConfigureCap.vue?vue&type=template&id=06f53552&scoped=true&"
import script from "./ConfigureCap.vue?vue&type=script&lang=js&"
export * from "./ConfigureCap.vue?vue&type=script&lang=js&"
import style0 from "./ConfigureCap.vue?vue&type=style&index=0&id=06f53552&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f53552",
  null
  
)

export default component.exports